import { useMemo } from "react"

export const useStackLegend = (props?: {
  show?: boolean
}) => useMemo(
  () => (props?.show !== false) && {
    type: 'scroll',
    orient: 'vertical',
    selectMode: 'multiple',
    backgroundColor: 'rgba(255,255,255,0.5)',
    padding: 10,
    right: 0,
    top: 0,
    bottom: 0
  },
  [props?.show]
)
